import { render, staticRenderFns } from "./SenderFactory.vue?vue&type=template&id=56940160"
import script from "./SenderFactory.vue?vue&type=script&lang=js"
export * from "./SenderFactory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports